// import * as d3 from 'd3';
import d3 from './d3-import.js';
import api from './api';
import utils from './utils';

const graph = {
    manifest: null,
    stateCount: null,

    //gets and store manifest and attaches event listeners to compare buttons
    init: function(){
        api.getManifest("/").then(res => {
            this.manifest = res.body;
        });
        document.querySelectorAll('button.tooltip').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                if(btn.classList.contains('open')){
                    btn.classList.remove('open');
                } else {
                    btn.classList.add('open');
                }
            });
        });
        document.querySelectorAll('.tier4 li button').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                if(btn.classList && btn.classList.contains('save-image')){
                    utils.domNodeImg('.tier4.data-tier li.compare', btn.dataset.title);
                } else {
                    let row = btn.closest('li');
                    if(row.classList.contains('compare')){
                        row.querySelector('.graph-row').style.maxHeight = '0px';
                        row.classList.remove('compare');
                        btn.setAttribute('aria-expanded', false);
                    } else {
                        let open = document.querySelector('li.compare');
                        if(open){
                            open.querySelector('.graph-row').style.maxHeight = '0px';
                            open.classList.remove('compare');
                            open.querySelector('button').setAttribute('aria-expanded', false);
                        }

                        btn.setAttribute('aria-expanded', true);
                        row.classList.add('compare');
                        let graphContainer = row.querySelector('.graph-row');
                        let height = graphContainer.scrollHeight;
                        graphContainer.style.maxHeight = `${height*2}px`;

                        let stateAbbr = btn.dataset.state;
                        let metricKey = btn.dataset.metric;
                        let metricValue = btn.dataset.value;
                        let graphEl = document.getElementById(`graph_${stateAbbr}_${metricKey}`);
                        if(graphEl.classList.contains('loading')){
                            this.renderGraph(graphEl,{
                                'stateAbbr': stateAbbr,
                                'metricKey': metricKey,
                                'metricValue': metricValue
                            });
                        }
                    }
                }
            });
        });

        window.addEventListener("resize",utils.debounce(function(e){
            document.querySelectorAll('.graph').forEach((graph) => {
                graph.innerHTML = '';
                graph.classList.add('loading');
                graph.closest('li').classList ? graph.closest('li').classList.remove('compare') : null;
            });
        }));
    },

    //rendered boolean data
    renderBoolViz: function(viz){
        let legendOffset = viz.size.width > 894 ? 225 : (viz.size.width > 590 ? 175 : 0);
        d3.json(viz.url+`&sortBy=${viz.metricKey}&order=desc`, (data) => {
            let circles = [];
            let states = [];
            let rowCount = viz.size.width > 894 ? 4 : (viz.size.width > 590 ? 6 : 13);
            let colCount = viz.size.width > 894 ? 13 : (viz.size.width > 590 ? 9 : 4);
            let gapRatio = viz.size.width > 894 ? .2 : (viz.size.width > 590 ? .1 : .2);
            let width = viz.size.width - legendOffset;
            let gapDist = (width / colCount) * gapRatio;
            let radii = (width / colCount)-gapDist;
            let vizHeight = viz.size.width > 590 ? width * (rowCount/colCount) : (rowCount+1) * (gapDist + radii) + 64;
            // console.log(viz.size.width,vizHeight,width,gapDist,radii);

            let color = d3.scaleLinear()
                .domain([0,1])
                .range(["#d48028","#1d9ad6"]);

            let legendText = ["No","Yes"];

            let svg = d3.select(viz.graphEl)
                .append("svg")
                .attr("class", "state-metric-bool")
                .attr("preserveAspectRatio","xMinYMin")
                .attr("width", viz.size.width)
                .attr("height", vizHeight)
                .attr("viewBox", "0 0 " + viz.size.width + " " + vizHeight);

            let legend = d3.select(viz.graphEl).append("div")
                .attr("transform", 'translate(20,0)')
                .attr("class", "bool-legend")
                .selectAll('.bool-legend div')
                .data([1,0])
                .enter().append("div");

            legend.append('span')
                .attr("class", "circle")
                .style("background-color", color);

            legend.append('span')
                .attr("class", "bool-legend-text")
                .text(function(d){
                    return legendText[d];
                });


            while(data.data.length > 0){
                let groups = data.data.splice(0,colCount);
                circles.push({states: groups});
            }

            circles.forEach((group,ix) => {
                (Object.values(group)[0]).forEach((item,i) => {
                    item.x = i * ((width/colCount)+(gapDist/colCount)) + (viz.size.width > 590 ? 0 : 5);
                    states.push(item);
                });
            })

            let dataCircles = svg.append("g")
                .attr("transform", `translate(${viz.size.width > 894 ? legendOffset : legendOffset - 5},${(legendOffset == 0 ? '64' : '0')})`)
                .attr("class", "boolean-states");

            let bools = dataCircles.selectAll('rect')
                .data(states)
                .enter().append("rect")
                .attr("class", (d) => {
                    return (d.abbr == viz.stateAbbr ? 'circle current' : 'circle');
                })
                .attr("rx",radii)
                .attr("ry",radii)
                .attr("x", (d) => {
                    return d.x;
                })
                .attr("y", (d, i) => {
                    return (parseInt(i/colCount) * (width / colCount))+5;
                })
                .attr("width", (d,i) => {
                    return d.abbr == viz.stateAbbr ? (radii - 5) : radii;
                })
                .attr("height", (d,i) => {
                    return d.abbr == viz.stateAbbr ? (radii - 5) : radii;
                })
                .style("fill", (d,i) => {
                    let val = d[viz.metricKey];
                    if(val){
                        if(d.abbr == viz.stateAbbr){
                            return '#fff';
                        } else {
                            return color(1);
                        }
                    } else {
                        if(d.abbr == viz.stateAbbr){
                            return '#fff';
                        } else {
                            return color(0);
                        }
                    }
                })
                .style("stroke", (d,i) => {
                    let val = d[viz.metricKey];
                    if(val){
                        if(d.abbr == viz.stateAbbr){
                            return color(1);
                        } else {
                            return 'transparent';
                        }
                    } else {
                        if(d.abbr == viz.stateAbbr){
                            return color(0);
                        } else {
                            return 'transparent';
                        }
                    }
                }).exit()
                .data(states)
                .enter().append('text')
                .attr("class", (d) => {
                    return (d.abbr == viz.stateAbbr ? 'current state-circle-text' : 'state-circle-text');
                })
                .attr("x", (d) => {
                    return (d.abbr == viz.stateAbbr ? d.x + ((radii - 5)/2) : d.x + (radii/2));
                })
                .attr("y", (d, i) => {
                    return (d.abbr == viz.stateAbbr ? ((parseInt(i/colCount) * (width / colCount)) + 5)+((radii - 5)/2) : ((parseInt(i/colCount) * (width / colCount)) + 5)+(radii/2));
                })
                .attr("dy", ".4em")
                .style("text-anchor", "middle")
                .text(function(d){
                    return d.abbr;
                });


            viz.graphEl.classList.remove('loading');

            setTimeout(() => {
                if(viz.graphEl.getBoundingClientRect().top < 138){
                    window.scrollTo({
                      top: viz.graphEl.offsetTop,
                      left: 0,
                      behavior: 'smooth'
                    });
                }
            }, 250);
        });
    },

    // gets all states values for clicked on row to create bar chart
    renderGraph: function(graphEl,row){
        let stateMetricsDataUrl = `/wp-json/wp/v2/states?fields=${row.metricKey}`;
        let graphWidth = graphEl.getBoundingClientRect().width;
        let graphHeight = graphWidth > 894 ? graphWidth * 0.3125 : 999;

        if(row.metricKey.substr(-1) == "b"){
            this.renderBoolViz({
                'url': stateMetricsDataUrl,
                'graphEl': graphEl,
                'size': {
                    'width': graphWidth
                },
                ...row
            });
        } else {
            let color = d3.scaleQuantize()
                .domain([1, 100])
                .range(["#d48028","#dcab27","#00b0ab","#1d9ad6"]);

            let legendText = Object.values(JSON.parse(statePercentiles));

            let svg = d3.select(graphEl)
                .append("svg")
                .attr("class", "state-metric-graph")
                .attr("preserveAspectRatio","xMinYMin")
                .attr("width", graphWidth)
                .attr("height", graphHeight)
                .attr("viewBox", "0 0 " + graphWidth + " " + graphHeight);

            let formatter = {
                format: function(input){
                    return input;
                }
            };
            let metric = this.manifest.find(metric => metric.key === row.metricKey);
            if(metric.unit == "$"){
                formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
            } else if(metric.unit == "%"){
                formatter.format = (input) => {
                    return `${input}%`;
                };
            }

            let yScaleOffset = (((formatter.format(Math.ceil(row.metricValue))).toString().length+1) * 6) + 12;
            let xScale = d3.scaleBand().range([0, (graphWidth > 894 ? (graphWidth-yScaleOffset) : graphHeight-32)]).padding(.5);
            let yScale = d3.scaleLinear().range([(graphWidth > 894 ? graphHeight-30 : 0), (graphWidth > 894 ? 0 : graphWidth-(yScaleOffset*1.5))]);
            let g = svg.append("g").attr("transform", `translate(${(graphWidth > 894 ? yScaleOffset : yScaleOffset)},${(graphWidth > 894 ? '6' : '16')})`);

            d3.json(stateMetricsDataUrl, (data) => {
                let states = data.data;
                this.stateCount = states.length;

                xScale.domain(states.map(function(d){
                    return d.abbr;
                }));

                let yMin = d3.min(states, function(d){
                    return d[row.metricKey];
                });
                let yMax = d3.max(states, function(d){
                    return d[row.metricKey];
                })
                let scaleMinY = yMin > 0 ? 0 : Math.floor(yMin);
                let scaleMaxY = yMax < 0 ? 0 : Math.ceil(yMax);
                let tickCount = (graphWidth > 300) ? 10 : 5;

                yScale.domain([scaleMinY,scaleMaxY]);

                if(graphWidth > 894){
                    g.append("g")
                        .attr("transform", "translate(0," + (graphHeight-30) + ")")
                        .call(d3.axisBottom(xScale));

                    g.append("g")
                        .call(d3.axisLeft(yScale).tickFormat(function(d){
                            return formatter.format(d);
                        }).ticks(tickCount))
                        .append("text")
                        .attr("y", 6)
                        .attr("dy", "0.71em")
                        .attr("text-anchor", "end")
                        .text("value");
                } else {
                    g.append("g")
                        .attr("transform", "translate(0,0)")
                        .call(d3.axisLeft(xScale));

                    g.append("g")
                        .attr("transform", "translate(0,0)")
                        .call(d3.axisTop(yScale).tickFormat(function(d){
                            return formatter.format(d);
                        }).ticks(tickCount))
                        .append("text")
                        .attr("y", 6)
                        .attr("dy", "0.71em")
                        .attr("text-anchor", "end")
                        .text("value");
                }

                g.selectAll(".bar")
                    .data(states)
                    .enter().append("g")
                    .attr("class", (d) => {
                        return (d.abbr == row.stateAbbr ? 'bar current' : 'bar');
                    })
                    .append((d,i) => {
                        let score = d[row.metricKey];
                        let fill = '#5D6367';
                        if(score){
                            let percentile = utils.percentile(states, row.metricKey, score);
                            fill = color(Math.ceil(percentile));
                        }
                        let fragment = document.createDocumentFragment();
                        let rectWidth = graphWidth > 894 ? (graphWidth-yScaleOffset)/103 : (graphHeight)/103;
                        if(d.abbr == row.stateAbbr){
                            let wrapper = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                            if(graphWidth > 894){
                                wrapper.setAttribute('x', xScale(d.abbr) - (rectWidth/2));
                                wrapper.setAttribute('y', 0);
                                wrapper.setAttribute('width', rectWidth*2);
                                wrapper.setAttribute('height', graphHeight);
                            } else {
                                wrapper.setAttribute('y', xScale(d.abbr) - (rectWidth/2));
                                wrapper.setAttribute('x', -30);
                                wrapper.setAttribute('height', rectWidth*2);
                                wrapper.setAttribute('width', graphWidth);
                            }
                            wrapper.setAttribute('fill', fill);
                            wrapper.setAttribute('class', 'wrapper');
                            fragment.appendChild(wrapper);
                        }
                        let rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
                        if(graphWidth > 894){
                            rect.setAttribute('x', xScale(d.abbr));
                            rect.setAttribute('y', yScale(d[row.metricKey]));
                            rect.setAttribute('width', xScale.bandwidth());
                            rect.setAttribute('height', (graphHeight-30) - yScale(d[row.metricKey]));
                        } else {
                            rect.setAttribute('y', xScale(d.abbr));
                            rect.setAttribute('x', 0);
                            rect.setAttribute('height', xScale.bandwidth());
                            rect.setAttribute('width', yScale(d[row.metricKey]));
                        }

                        rect.setAttribute('fill', fill);
                        fragment.appendChild(rect);

                        return fragment;
                    });

                let legend = d3.select(graphEl)
                    .append("div")
                    .attr("class", "legend")
                    .attr("width", (graphWidth*.7))
                    .selectAll(".legend div")
                    .data([100,75,50,25])
                    .enter().append("div");

                legend.append("span")
                    .attr("class", "circle")
                    .style("background-color", color);

                legend.append("span")
                    .data(legendText)
                    .text(function(d){
                        return d;
                    });

                graphEl.classList.remove('loading');

                setTimeout(() => {
                    if(graphEl.getBoundingClientRect().top < 138){
                        window.scrollTo({
                          top: graphEl.offsetTop,
                          left: 0,
                          behavior: 'smooth'
                        });
                    }
                }, 250);
            });
        }
    },
};

export default graph;
